"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventRsvpBlastResultDto = exports.EventRsvpBlastAudienceDto = void 0;
const swagger_1 = require("@nestjs/swagger");
/** Who an RSVP blast would reach, and why the rest are left out. */
class EventRsvpBlastAudienceDto {}
exports.EventRsvpBlastAudienceDto = EventRsvpBlastAudienceDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventRsvpBlastAudienceDto.prototype, "eventPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventRsvpBlastAudienceDto.prototype, "eventName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], EventRsvpBlastAudienceDto.prototype, "venueName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Event end (ISO); a blast for an ended event is refused.'
}), __metadata("design:type", Object)], EventRsvpBlastAudienceDto.prototype, "eventEndDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Everyone with an RSVP on the event.'
}), __metadata("design:type", Number)], EventRsvpBlastAudienceDto.prototype, "rsvpCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Left out: deleted, inactive or locked-out accounts.'
}), __metadata("design:type", Number)], EventRsvpBlastAudienceDto.prototype, "excludedInactive", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Left out: internal (team / test) users, unless included.'
}), __metadata("design:type", Number)], EventRsvpBlastAudienceDto.prototype, "excludedInternal", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Left out: already hold a ticket for this event, when that option is on.'
}), __metadata("design:type", Number)], EventRsvpBlastAudienceDto.prototype, "excludedTicketHolders", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Who the blast is sent to.'
}), __metadata("design:type", Number)], EventRsvpBlastAudienceDto.prototype, "recipientCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Recipients with push turned on (the rest are logged as skipped).'
}), __metadata("design:type", Number)], EventRsvpBlastAudienceDto.prototype, "reachableCount", void 0);
class EventRsvpBlastResultDto {}
exports.EventRsvpBlastResultDto = EventRsvpBlastResultDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], EventRsvpBlastResultDto.prototype, "recipientCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Pushes OneSignal accepted.'
}), __metadata("design:type", Number)], EventRsvpBlastResultDto.prototype, "sentCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'No push token / invalid token.'
}), __metadata("design:type", Number)], EventRsvpBlastResultDto.prototype, "skippedCount", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], EventRsvpBlastResultDto.prototype, "failedCount", void 0);
//# sourceMappingURL=EventRsvpBlast.dto.js.map